import { render, staticRenderFns } from "./ProfileBanker.vue?vue&type=template&id=416207aa&scoped=true&"
import script from "./ProfileBanker.vue?vue&type=script&lang=ts&"
export * from "./ProfileBanker.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileBanker.vue?vue&type=style&index=0&id=416207aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416207aa",
  null
  
)

export default component.exports